import { useRef } from 'react';
import styles from './socialProofScreen.module.css';
import WorksCarousel from '../../components/worksCarousel/WorksCarousel';
import CertsCarousel from '../../components/certsCarousel/CertsCarousel';
import TestimonialsGrid from './TestimonialsGrid';
import useScrollReveal from '../../hooks/useScrollReveal';

function SocialProofScreen() {
  const sectionRef = useRef(null);
  useScrollReveal(sectionRef);

  return (
    <div ref={sectionRef}>
    <section className={styles.proof} id="proof">
      <div className={styles.glowTop} />
      <div className={styles.glowBottom} />
      <span className={`${styles.star} ${styles.star1}`}>✦</span>
      <span className={`${styles.star} ${styles.star2}`}>✦</span>
      <span className={`${styles.star} ${styles.star3}`}>✧</span>
      <span className={`${styles.star} ${styles.star4}`}>✦</span>
      <span className={`${styles.star} ${styles.star5}`}>✧</span>
      <span className={`${styles.star} ${styles.star6}`}>✦</span>

      {/* ── Title 1 ── */}
      <div className={styles.titleWrap} data-sr="0">
        <h2 className={styles.sectionTitle}>
          בשנים האחרונות עברו תחתי{' '}
          <em className={styles.highlight}>אלפי נשים.</em>
        </h2>
      </div>

      {/* ── Carousel 1: works ── */}
      <div className={styles.carouselSection}>
        <WorksCarousel />
      </div>

    </section>

    {/* ── Certs section  -  fully outside proof to avoid overflow:hidden ── */}
    <div className={styles.certsSection}>
      <div className={styles.titleWrap} data-sr="0.06">
        <h2 className={styles.sectionTitle}>
          ועשרות נשים שכבר הפכו את התשוקה{' '}
          <em className={styles.highlight}>לקריירה רווחית</em>
        </h2>
      </div>

      <CertsCarousel />
    </div>

    {/* ── Testimonials grid: videos + images  -  right after second carousel ── */}
    <TestimonialsGrid />
    </div>
  );
}

export default SocialProofScreen;
